import type { Feature, Polygon } from "geojson";
import { isPointInPolygon } from "../../../domain/geometry/spatial/pointInPolygon";
import type { LassoMetadata, LassoFeatureType } from "../tools/types";

export interface LassoSelectInput {
	/** The lasso polygon drawn by the user */
	lasso: Feature<Polygon>;
	/** Candidate features with coords for containment check */
	candidates: LassoMetadata[];
	/** Optional filter — only check candidates of this type */
	featureTypeFilter?: LassoFeatureType;
}

/**
 * Find all candidate features contained within the lasso polygon.
 * A candidate is selected if ANY of its coords are inside the lasso.
 * Pure query — no command needed (selection is UI state, not undoable).
 */
export function lassoSelectUseCase(input: LassoSelectInput): string[] {
	const filtered = input.featureTypeFilter
		? input.candidates.filter((c) => c.featureType === input.featureTypeFilter)
		: input.candidates;

	return filtered.filter((c) => c.coords.some((coord) => isPointInPolygon(coord, input.lasso))).map((c) => c.id);
}
